export class AudioInfo{
    constructor(id, name, url, poster, type, audioId) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.poster = poster;
        this.type = type
        this.audioId = audioId
    }
}

